import {
  NumericFormatType,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { DRIssueAndCancelActivityModel } from './dr-issue-and-cancel-activity.model';

export class DRIssueAndCancelActivityConfiguration extends ReportSectionConfigurationBase {
  typeName = 'DRIssueAndCancelActivityConfiguration';
  nodataLocalizationKeyName = 'bnyManagementMonthlyDRIssueAndCancelActivity';
  readonly reportSection = ReportSection.DRIssueAndCancelActivity;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_DRIssueAndCancelActivity];
  minSize = 3;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'month',
      displayName: 'Month',
      isSelected: true,
      canConfigure: false,
      unit: 1,
      property: 'date',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Date
    },
    {
      name: 'drsIssued',
      displayName: 'DRs Issued',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drsIssued',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsCancelled',
      displayName: 'DRs Cancelled',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drsCancelled',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'netIssueCancel',
      displayName: 'Net Issue/Cancel',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'netIssueCancel',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsOutstanding',
      displayName: 'DRs Outstanding',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drsOutstanding',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsOutstandingChangePct',
      displayName: 'DRs Outstanding Change, %',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drsOutstandingChangePct',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.Percentage
    },
    {
      name: 'monthEndDrPrice',
      displayName: 'Month End DR Price',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'monthEndDrPrice',
      type: ReportSectionConfigurationControlType.Decimal
    },
    {
      name: 'drMarketCapitalizationUsd',
      displayName: 'DR Market Capitalization, USD',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'drMarketCapitalizationUsd',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'registeredDrHolders',
      displayName: 'Registered DR Holders',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'registeredDrHolders',
      type: ReportSectionConfigurationControlType.Number
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'drIssueAndCancelActivity';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Monthly DR Issue & Cancel Activity';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface DRIssueAndCancelActivityData {
  [ReportViewModelSection.BnyManagementReport_DRIssueAndCancelActivity]: {
    drIssueAndCancelActivity: DRIssueAndCancelActivityModel[];
  };
}
